import * as React from "react";
import { cn } from "./cn";

type Tone = "gold" | "teal" | "muted" | "success";

// N24 badge anatomy: smaller, semibold, tinted rather than saturated where the
// tone allows (muted). Solid tones take BOTH colours from the theme's pair, so
// the ink is the one theme.ts computed for contrast. `teal` is the brand alias
// of the portal's primary; it used to force white ink, unreadable the day a
// portal picks a pale primary. `success` used the legacy lime with teal ink
// and ignored the themeable success pair altogether (2026-09-14 review).
const tones: Record<Tone, string> = {
  gold: "bg-gold text-accent-foreground",
  teal: "bg-teal text-primary-foreground",
  muted: "bg-muted text-mid-gray",
  success: "bg-success text-success-foreground",
};

export function Badge({
  tone = "gold",
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        "inline-block font-display font-semibold text-[12px] leading-5 px-2.5 py-0.5 rounded-pill uppercase tracking-[0.06em]",
        tones[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
